import React from 'react'
import Container from '../../../layouts/Container'
export default function Profile() {
  return (
    <Container>
      <div>Profile</div>
    </Container>
  )
}
